export const trackingEvents = {
  DOWNLOAD_CSV_BUTTON: {
    CLICKED: 'employers.download_csv_button.clicked',
  },
}
